import axios from 'axios';
import qs from 'qs';
axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
export const restMethods = {
  methods: {
    async getMethod(path, params = {}, config = {}){
      return await axios.get(path, {params: params}, config);
    },
    async postMethod(path, params = {}, config = {}){
      return await axios.post(path, params, config);
    },
    async putMethod(path, params = {}, config = {}){
      return await axios.put(path, params, config);
    },
    async deleteMethod(path, params = {}, config = {}){
      return await axios.delete(path, params, config);
    }
  }
}